var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 219,
    height: 220,
    viewBox: "0 0 219 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.7413 84.3973V220.001C86.5638 220.001 87.3863 220.001 88.2089 220.001C113.354 218.688 132.703 196.819 132.703 171.286V132.094H170.618C183.258 132.022 195.363 126.981 204.321 118.058C213.279 109.134 218.372 97.0447 218.5 84.3973H85.7413Z",
    fill: "url(#paint0_linear_3235_17431)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.396393 0V220C17.3357 219.995 33.6768 213.714 46.2862 202.363C53.5157 195.73 59.27 187.641 63.1732 178.625C67.0764 169.608 69.0408 159.867 68.9382 150.038V68.0421H149.45C167.54 68.0149 184.899 60.8766 197.806 48.1575C210.714 35.4383 218.143 18.1506 218.5 0L0.396393 0Z",
    fill: "url(#paint1_linear_3235_17431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_17431",
    x1: 152.121,
    y1: 84.3973,
    x2: 152.121,
    y2: 220.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_17431",
    x1: 109.448,
    y1: 0,
    x2: 109.448,
    y2: 220,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EB683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EB683",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignBottom);
export default __webpack_public_path__ + "static/media/design-bottom.322721a2924c736769599a85dec4d221.svg";
export { ForwardRef as ReactComponent };